import {
  ODataHeader,
  ODataString,
  ODataDateTime,
  ODataCustom,
  ODataBooleanIs,
} from "pbas-vue-components";
import { translate2 } from "../trans2";

function getEligibilityReportsHeaders(dateString) {
  console.log(dateString);
  return [
    new ODataHeader({
      title: "ID",
      type: new ODataString("Id"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      isIdentifier: true,
      version: 1,
    }),
    new ODataHeader({
      title: "globals.certificate",
      type: new ODataString("MemberIdentification/Certificate"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "globals.firstname",
      type: new ODataString("CurrentMember/FirstName"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "globals.lastname",
      type: new ODataString("CurrentMember/LastName"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "globals.employer",
      type: new ODataString(
        "CurrentEmploymentInformation/Employer/Current/Translations[]/Name",
        {
          getString: (item) =>
            item.CurrentEmploymentInformation !== null &&
            item.CurrentEmploymentInformation !== undefined &&
            item.CurrentEmploymentInformation.Employer !== null &&
            item.CurrentEmploymentInformation.Employer !== undefined
              ? translate2(item.CurrentEmploymentInformation.Employer.Current, "Name")
              : "",
          getHtml: (item, type) => {
            return (
              "<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
              type.getString(item, type) +
              "</div>"
            );
          },
        }
      ),
      sortable: true,
      visible: true,
      searchable: true,
      orderByKey: "CurrentEmploymentInformation/Employer/Current/Name",
    }),
    new ODataHeader({
      type: new ODataString(
        "CurrentEmploymentInformation/Employer/Current/Translations[]/LanguageCode"
      ),
      sortable: false,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      title: "globals.store",
      type: new ODataString(
        "CurrentEmploymentInformation/Store/Current/Translations[]/Name",
        {
          getString: (item) =>
            item.CurrentEmploymentInformation !== null &&
            item.CurrentEmploymentInformation !== undefined &&
            item.CurrentEmploymentInformation.Store !== null &&
            item.CurrentEmploymentInformation.Store !== undefined
              ? translate2(item.CurrentEmploymentInformation.Store.Current, "Name")
              : "",
          getHtml: (item, type) => {
            return (
              "<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
              type.getString(item, type) +
              "</div>"
            );
          },
        }
      ),
      sortable: true,
      visible: true,
      searchable: true,
      orderByKey: "CurrentEmploymentInformation/Store/Current/Name",
    }),
    new ODataHeader({
      type: new ODataString(
        "CurrentEmploymentInformation/Store/Current/Translations[]/LanguageCode"
      ),
      sortable: false,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      title: "globals.member_group",
      type: new ODataString(
        "CurrentMembershipStatus/MemberGroupIdentity/Current/Translations[]/Name",
        {
          getString: (item) =>
            item.CurrentMembershipStatus !== null &&
            item.CurrentMembershipStatus !== undefined &&
            item.CurrentMembershipStatus.MemberGroupIdentity !== null &&
            item.CurrentMembershipStatus.MemberGroupIdentity !== undefined
              ? translate2(
                  item.CurrentMembershipStatus.MemberGroupIdentity.Current,
                  "Name"
                )
              : "",
          getHtml: (item, type) => {
            return (
              "<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
              type.getString(item, type) +
              "</div>"
            );
          },
        }
      ),
      sortable: true,
      visible: true,
      searchable: true,
      orderByKey: "CurrentMembershipStatus/MemberGroupIdentity/Current/Name",
    }),
    new ODataHeader({
      type: new ODataString(
        "CurrentMembershipStatus/MemberGroupIdentity/Current/Translations[]/LanguageCode"
      ),
      sortable: false,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      title: "globals.class",
      type: new ODataString("CurrentMembershipStatus/Class"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "components.memberview.eligible",
      sortable: true,
      searchable: true,
      type: new ODataCustom("EligibleExpiryDate", {
        getValue: (item) => {
          if (
            item.EligibleEffectiveDate === null ||
            item.EligibleEffectiveDate === undefined
          ) {
            return false;
          }
          const date = Date.parse(dateString);
          const eligibleEffectiveDate = Date.parse(item.EligibleEffectiveDate);
          if (date < eligibleEffectiveDate) {
            return false;
          }
          if (
            item.EligibleExpiryDate === null ||
            item.EligibleExpiryDate === undefined
          ) {
            return true;
          }
          const eligibleExpiryDate = Date.parse(item.EligibleExpiryDate);
          return date < eligibleExpiryDate;
        },
        getString: (item, type) => {
          return type.getValue(item).toString();
        },
        getWildcardFilter: (search) => {
          if (
            search.toLowerCase() === "true"
          ) {
            return `EligibleEffectiveDate ne null and (EligibleExpiryDate eq null or EligibleExpiryDate gt ${dateString.split('T')[0]})`;
          } else if (
            search.toLowerCase() === "false"
          ) {
            return `EligibleEffectiveDate eq null or  (EligibleExpiryDate ne null and EligibleExpiryDate lt ${dateString.split('T')[0]})`;
          }
          return undefined;
        },
        getFilter: (callback) => {
          // variable === "pbascomponents.operators.true" || variable.toLowerCase() === "true" ? `${name} eq true` : `${name} eq false`
          // return undefined;
          const res = callback("wtf");
          console.log(res);
          if (res === "wtf eq true") {
            return `EligibleEffectiveDate ne null and (EligibleExpiryDate eq null or EligibleExpiryDate gt ${dateString.split('T')[0]})`
          }
          return `EligibleEffectiveDate eq null or  (EligibleExpiryDate ne null and EligibleExpiryDate lt ${dateString.split('T')[0]})`;
        },
        operators: [new ODataBooleanIs()],
      }),
      // subHeaders: [
      //   new ODataHeader({
      //     type: new ODataDateTime("EligibleEffectiveDate"),
      //     visible: false,
      //     searchable: false,
      //     sortable: true,
      //     allowVisibilityChange: false,
      //   }),
      // ],
    }),
    new ODataHeader({
      type: new ODataDateTime("EligibleEffectiveDate"),
      visible: false,
      searchable: false,
      sortable: true,
      allowVisibilityChange: false,
    }),
    // new ODataHeader({
    //   title: "components.memberview.eligible",
    //   type: new ODataDateTime("EligibleExpiryDate", {
    //     getValue: (item) => {
    //       if (
    //         item.EligibleEffectiveDate === null ||
    //         item.EligibleEffectiveDate === undefined
    //       ) {
    //         return false;
    //       }
    //       const date = Date.parse(dateString);
    //       const eligibleEffectiveDate = Date.parse(item.EligibleEffectiveDate);
    //       if (date < eligibleEffectiveDate) {
    //         return false;
    //       }
    //       if (
    //         item.EligibleExpiryDate === null ||
    //         item.EligibleExpiryDate === undefined
    //       ) {
    //         return true;
    //       }
    //       const eligibleExpiryDate = Date.parse(item.EligibleExpiryDate);
    //       return date < eligibleExpiryDate
    //     },
    //     getString: (item, type) => {
    //       return type.getValue(item).toString();
    //     }
    //   }),
    //   sortable: true,
    //   visible: true,
    //   searchable: true,
    // }),
    // new ODataHeader({
    //   type: new ODataDateTime("EligibleEffectiveDate"),
    //   sortable: false,
    //   visible: false,
    //   searchable: false,
    //   allowVisibilityChange: false,
    // }),
    new ODataHeader({
      title: "globals.coverage",
      type: new ODataString(
        "CurrentActiveMemberBenefits[]/CurrentBenefit/Translations[]/Name",
        {
          getString: (item) =>
            item.CurrentActiveMemberBenefits !== null &&
            item.CurrentActiveMemberBenefits !== undefined
              ? item.CurrentActiveMemberBenefits.map((c) =>
                  translate2(c.CurrentBenefit, "Name")
                ).join(", ")
              : "",
          getHtml: (item, type) => {
            return (
              "<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
              type.getString(item, type) +
              "</div>"
            );
          },
        }
      ),
      sortable: false,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      type: new ODataString(
        "CurrentActiveMemberBenefits[]/CurrentBenefit/Translations[]/LanguageCode"
      ),
      sortable: false,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
  ];
}
export default getEligibilityReportsHeaders;
